export const FEEDBACK_URL =
  'https://www.surveymonkey.com/r/carejourneyuserfeedback';
export const FEEDBACK_TEXT = 'Feedback';
export const SUPPORT_URL = 'http://carejourney.com/support';
export const SUPPORT_TEXT = 'Support';
export const PRIVACY_POLICY_URL = 'https://carejourney.com/privacy-policy/';
export const PRIVACY_POLICY_TEXT = 'Privacy Policy';
export const COPYRIGHT_TEXT = '© Copyright';
export const ALL_RIGHTS_RESERVED_TEXT = 'CareJourney - All Rights Reserved';
